import { type Action, createReducer, on } from '@ngrx/store';

import { mapMimeTypeToExtension, sanitizeExtensions } from '../../../util/public-api';

import { resetSettingsState, setUploaderOptions } from './settings.actions';

const defaultFileExtensions = [
  '.jpeg',
  '.jpg',
  '.png',
  '.mp4',
  '.pdf',
  '.xls',
  '.doc',
  '.ppt',
  '.xlsx',
  '.docx',
  '.pptx',
];

export interface SettingsState {
  acceptedFileExtensions: string[];
  isMultipleSelection: boolean;
  minimumImageDimensions?: [number, number];
  forceCrop?: boolean;
  cropForceAspectRatio?: { width: number; height: number };
  cropMaximumImageSize?: { width?: number; height?: number };
  accountId?: string;
  projectId?: string;
  isSecure?: boolean;
  category?: 'Icon' | 'None';
}

export const initialState: SettingsState = {
  acceptedFileExtensions: defaultFileExtensions,
  isMultipleSelection: true,
  minimumImageDimensions: undefined,
  forceCrop: false,
  cropForceAspectRatio: undefined,
  cropMaximumImageSize: undefined,
  accountId: undefined,
  projectId: undefined,
  isSecure: undefined,
  category: undefined,
};

const settingsReducerFn = createReducer(
  initialState,
  on(resetSettingsState, () => ({ ...initialState })),
  on(setUploaderOptions, (state, { options }) => ({
    ...state,
    accountId: options.accountId,
    acceptedFileExtensions: sanitizeExtensions(
      (options.acceptedFileTypes || []).map(mapMimeTypeToExtension),
    ),
    isMultipleSelection: options.isMultipleSelection || false,
    minimumImageDimensions: options.minimumImageDimensions,
    forceCrop: options.forceCrop,
    cropForceAspectRatio: options.cropForceAspectRatio,
    cropMaximumImageSize: options.cropMaximumImageSize,
    projectId: options.projectId,
    isSecure: options.isSecure,
    category: options.category,
  })),
);

export function settingsReducer(state: SettingsState | undefined, action: Action): SettingsState {
  return settingsReducerFn(state, action);
}
